import { getStore } from 'app/state/storeRegistry'
import { getMapConfigForAgent } from '../state/builderSliceUtils'
import { BuilderGenAIEnvironment } from '../types'
import { createAgent } from '../api/genAi'
import { sendMetricEvent } from 'features/metrics/model/metricsMutations'
import { MetricEventType } from 'features/metrics/api/metrics'

export async function updateAIMapAgent(environment: BuilderGenAIEnvironment) {
  const store = getStore()
  const map = store.getState().maps.currentMap
  const mapId = map?.id || ''
  const currentMapDatasets = store.getState().maps.currentMapDatasets
  const layers = store.getState().keplerGl.map.visState.layers
  const mapConfig = getMapConfigForAgent({ map, currentMapDatasets, layers })
  const userContext = store.getState().builder.aiSettings.mapContext

  if (!mapConfig) return

  const { agent, createdAt } = await createAgent({ mapId, mapConfig, userContext, environment })
  sendMetricEvent(MetricEventType.CARTOAIAgentCreated, {
    mapId: map.id,
    assistantId: agent,
    timestamp: createdAt,
    environment
  })
}
